import { IStoreApiItem, StoreApiItem } from '@/common/interfaces/store-api-item.interface'
import { IStoreApiList, StoreApiList } from '@/common/interfaces/store-api-list.interface'

import { ITranslationResponse, ITranslations } from 'src/features/translations/interfaces/translate.interface'

export interface ITranslationState {
  translations: IStoreApiList<ITranslations>
  translation: IStoreApiItem<ITranslationResponse>
}

export class TranslationState implements ITranslationState {
  translations: IStoreApiList<ITranslations> = new StoreApiList()
  translation: IStoreApiItem<ITranslationResponse> = new StoreApiItem()
}
